import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { ModalCesantiaVejez } from './ModalCesantiaVejez';
import { ModalDetalles } from './ModalDetalles';


import servicioHttp from '../../../servicio/ServicioHttp';

export const TablaCesantiaVejez = (props) => {

    const { growl } = props;
    const [datosTabla, setDatosTabla] = useState([]);
    const [verModal, setVerModal] = useState(false);
    const [verModalDetalles, setVerModalDetalles] = useState(false);
    const [datosTablaCalculos, setDatosTablaCalculos] = useState([]);
    const titulo = "Cesantía y vejez anual";

    useEffect(() => {
        cargarDatos();
    }, []);

    const cargarDatos = () => {
        servicioHttp.consumirPostHttp('tablas/cesantiavejezpatronal/consultar.json').then(response => {
            setDatosTabla(response.data.lista);
        }).catch(error => {

        });
    }


    const verDetalles = (id) => {
        servicioHttp.consumirPostHttp("tablas/cesantiavejezpatronal/buscar_solicitud.json", { id }).then(response => {
            let datosResponse = response.data.lista;
            setDatosTablaCalculos(datosResponse);
            mostrarModalDetalles();
        }).catch(error => {

        });
    }

    const eliminar = (id) => {
        growl.current.clear();
        servicioHttp.consumirPostHttp("tablas/cesantiavejezpatronal/eliminar_solicitud.json", { id }).then(response => {
            cargarDatos();
        }).catch(error => {
            growl.current.show({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error en el servidor, por favor vuelva a intentar.' });
        });
    }


    const columnaOpciones = (rowData, column) => {
        return <div className="p-grid" style={{ width: "150px" }}>
            <div className="p-col-12 p-md-3">
                <Button
                    type="button"
                    icon="pi-md-pageview"
                    onClick={(e) => verDetalles(rowData.id)}
                    className="p-button-warning"
                    name="Ver Detalles"
                    tooltip="Ver Detalles">
                </Button>
            </div>
            <div className="p-col-12 p-md-3">
                <Button
                    type="button"
                    icon="pi-md-trash"
                    onClick={(e) => eliminar(rowData.id)}
                    className="p-button-error"
                    name="Eliminar"
                    tooltip="Eliminar">
                </Button>
            </div>
        </div>;
    }

    const mostrarModal = () => {
        setVerModal(true);
    }

    const cerrarVerModal = (value) => {
        setVerModal(value);
    }


    const mostrarModalDetalles = () => {
        setVerModalDetalles(true);
    }

    const cerrarVerModalDetalles = (value) => {
        setVerModalDetalles(value);
    }

    return (<div className="card">
        <div className="p-grid">
            <div className="p-col-12">
                <Button className="p-button-primary" label="Agregar"
                    icon="pi-md-plus" tooltip={"Agregar"} onClick={mostrarModal} />
            </div>
        </div>
        <DataTable value={datosTabla} responsive={true} header={titulo}
            paginator={true}
            rows={20}
            autoLayout={true}>
            <Column header="Año" field="anio" />
            <Column header="Salario Mínimo" field="salarioMinimo" />
            <Column header="Uma" field="uma" />
            <Column header="Opciones" body={columnaOpciones} />
        </DataTable>

        {verModal ? <ModalCesantiaVejez verModal={verModal} cerrarVerModal={cerrarVerModal} growl={growl} refrescarTabla={cargarDatos} /> : null}
        {verModalDetalles ? <ModalDetalles verModal={verModalDetalles} cerrarVerModal={cerrarVerModalDetalles} datosTablaCalculos={datosTablaCalculos} /> : null}
    </div>);
}